import { render, staticRenderFns } from "./DetailHealthInfo.vue?vue&type=template&id=26f0cb36&"
import script from "./DetailHealthInfo.vue?vue&type=script&lang=js&"
export * from "./DetailHealthInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports